// extracted by mini-css-extract-plugin
export default {"stack":"Stack_stack__nSXBK","stack--no-reference":"Stack_stack--no-reference__94Nr5","stack--reference-first-child":"Stack_stack--reference-first-child__Tiwlc"};